import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Container from '@mui/material/Container';

import { TertiaryButton } from '../button';
import { getRating, OVERRIDES } from '../../utils/get-rating-provider';
import { useGutterSpacing } from '../../hooks/use-gutter-spacing';
import { RATERS } from '../../constants';
import { H3, P } from '../type';
import VehicleCard from '../vehicle-card';

import { BrowseButtonWrapper, StyledGrid, TextBlock, Title, VehicleCardWrapper } from './styles';

const CardListing = ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'cars' implicitly has an 'any' type.
  cars,
  gtmEvent = null,
  hasShowMoreButton = false,
  intro = null,
  onShowMoreClick = _.noop,
  title = null,
}) => {
  return (
    <Container maxWidth="xl">
      <TextBlock>
        {title && (
          <Title>
            <H3 as="h2">{title}</H3>
          </Title>
        )}
        {intro && <P>{intro}</P>}
      </TextBlock>
      <StyledGrid container spacing={useGutterSpacing()}>
        {_.map(cars, (car, index) => {
          return (
            <StyledGrid item xs={12} sm={6} lg={3} key={index}>
              <VehicleCardWrapper>
                <VehicleCard
                  {...{
                    ...car,
                    rating: getRating(
                      {
                        ratingProviderOverride: OVERRIDES.COPRESENTATIONAL,
                        ancapRating: car.ratingBy === RATERS.ANCAP ? car.stars : 0,
                        ucsrRating: car.ratingBy === RATERS.UCSR ? car.stars : 0,
                      },
                      { ratingYear: car.ANCAPTestYear }
                    ),
                    gtmEvent,
                  }}
                />
              </VehicleCardWrapper>
            </StyledGrid>
          );
        })}
      </StyledGrid>
      {hasShowMoreButton && (
        <BrowseButtonWrapper>
          <TertiaryButton onClick={onShowMoreClick}>Browse more cars</TertiaryButton>
        </BrowseButtonWrapper>
      )}
    </Container>
  );
};

CardListing.propTypes = {
  cars: PropTypes.arrayOf(
    PropTypes.shape({
      ANCAPTestYear: PropTypes.number,
      image: PropTypes.string,
      make: PropTypes.string.isRequired,
      model: PropTypes.string.isRequired,
      priceRange: PropTypes.shape({
        low: PropTypes.number,
        high: PropTypes.number,
      }),
      recommendedSafetyFeatures: PropTypes.number.isRequired,
      totalSafetyFeatures: PropTypes.number.isRequired,
      year: PropTypes.number.isRequired,
    })
  ).isRequired,
  gtmEvent: PropTypes.string,
  hasShowMoreButton: PropTypes.bool,
  intro: PropTypes.string,
  onShowMoreClick: PropTypes.func,
  title: PropTypes.string,
};

export default CardListing;
